import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
  getToken,
} from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD_-PP1hCR8saePZtQ9EbezXQ1Tw9_u_AM",
  authDomain: "ibonn-ifaste.firebaseapp.com",
  projectId: "ibonn-ifaste",
  storageBucket: "ibonn-ifaste.appspot.com",
  messagingSenderId: "67707905878",
  appId: "1:67707905878:web:f3aca33bac52b1744218f7",
  measurementId: "G-VQWM2SGC73",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Initialize App Check with ReCaptcha v3
// Get your site key from: https://www.google.com/recaptcha/admin
const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || "";

let appCheck = null;

if (RECAPTCHA_SITE_KEY) {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(RECAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export { appCheck };

// Firebase ID tokens expire after one hour. Always ask Firebase for the
// current token (it refreshes it when needed) instead of reusing the one
// stored at login, and keep sessionStorage in sync for the rest of the app.
export const getIdToken = async (forceRefresh = false) => {
  try {
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) return sessionStorage.getItem("token");
    const token = await user.getIdToken(forceRefresh);
    sessionStorage.setItem("token", token);
    return token;
  } catch (error) {
    console.error("[Auth] Failed to refresh ID token:", error);
    return sessionStorage.getItem("token");
  }
};

export const hasFirebaseUser = () => !!auth.currentUser;

// Helper function to get App Check token
export const getAppCheckToken = async () => {
  console.log("[App Check] Attempting to get App Check token...");

  if (!appCheck) {
    console.warn("[App Check] App Check is not initialized. Missing ReCaptcha site key.");
    console.warn("[App Check] RECAPTCHA_SITE_KEY:", RECAPTCHA_SITE_KEY ? "SET" : "NOT SET");
    return null;
  }

  try {
    console.log("[App Check] Fetching token from Firebase...");
    const tokenResult = await getToken(appCheck, false);
    console.log("[App Check] ✅ Token fetched successfully!");
    console.log("[App Check] Token preview:", tokenResult.token.substring(0, 50) + "...");
    return tokenResult.token;
  } catch (error) {
    console.error("[App Check] ❌ Failed to get App Check token:", error);
    return null;
  }
};
